import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const GlobeIcon = (props: IconProps) => (
  <ChakraIcon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 2a15 15 0 0 1 0 20a15 15 0 0 1 0-20" />
    <line x1="2" y1="12" x2="22" y2="12" />
  </ChakraIcon>
)

export default GlobeIcon
